/* eslint-disable react/prop-types */
import { Modal, Typography } from "@mui/material";
import { IconAlertTriangle } from "@tabler/icons";
import { Box } from "@mui/system";
import React from "react";

function SessionExpire({ open }) {
  return (
    <Modal open={open}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: {
            xs: "90%",
            sm: 400,
          },
          bgcolor: "#fff",
          borderRadius: "20px",
          p: 4,
          textAlign: "center",
          boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
          outline: "none",
        }}
      >
        {/* Icon */}
        <Box
          sx={{
            width: 90,
            height: 90,
            borderRadius: "50%",
            backgroundColor: "#fff4e5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto",
            mb: 2,
          }}
        >
          <IconAlertTriangle
            size={55}
            color="#ff9800"
          />
        </Box>

        {/* Title */}
        <Typography
          variant="h5"
          fontWeight="700"
          sx={{
            mb: 1,
            color: "#222",
          }}
        >
          Session Expired
        </Typography>

        {/* Message */}
        <Typography
          variant="body1"
          sx={{
            color: "#666",
            lineHeight: 1.8,
            mb: 4,
          }}
        >
          Your session has expired. This may be due to login activity on another
          device or a security timeout. Please login again.
        </Typography>
      </Box>
    </Modal>
  );
}

export default SessionExpire;
